import { apiClient } from "./client";
import type {
  MarkAllNotificationsReadResult,
  MyCommentFeed,
  MyCommentListParams,
  NotificationFeed,
  NotificationListParams,
  NotificationRecord,
} from "../types/notification";

interface DataEnvelope<TData> {
  data: TData;
}

export async function listNotifications(params?: NotificationListParams) {
  const response = await apiClient.get<DataEnvelope<NotificationFeed>>("/notifications/", {
    params,
  });
  return response.data.data;
}

export async function listUnreadNotifications() {
  const response = await apiClient.get<DataEnvelope<NotificationFeed>>("/notifications/unread/");
  return response.data.data;
}

export async function markNotificationRead(notificationId: number | string) {
  const response = await apiClient.post<DataEnvelope<NotificationRecord>>(
    `/notifications/${notificationId}/read/`,
    {},
  );
  return response.data.data;
}

export async function markAllNotificationsRead() {
  const response = await apiClient.post<DataEnvelope<MarkAllNotificationsReadResult>>(
    "/notifications/mark-all-read/",
    {},
  );
  return response.data.data;
}

export async function listMyComments(params?: MyCommentListParams) {
  const response = await apiClient.get<DataEnvelope<MyCommentFeed>>("/notifications/my-comments/", {
    params,
  });
  return response.data.data;
}

export async function markCommentEntityRead(entityType: "REQUISITION" | "PURCHASE_ORDER", entityId: string) {
  const response = await apiClient.post<DataEnvelope<MarkAllNotificationsReadResult>>(
    "/notifications/mark-comment-entity-read/",
    {
      entity_type: entityType,
      entity_id: entityId,
    },
  );
  return response.data.data;
}

export async function markAllCommentsRead() {
  const response = await apiClient.post<DataEnvelope<MarkAllNotificationsReadResult>>(
    "/notifications/mark-all-comments-read/",
    {},
  );
  return response.data.data;
}
